// Indonesian translations (Bahasa Indonesia)
import type { TranslationKeys } from './en';

export const id: TranslationKeys = {
  // Common
  common: {
    home: 'Beranda',
    settings: 'Pengaturan',
    language: 'Bahasa',
    loading: 'Memuat...',
    save: 'Simpan',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    close: 'Tutup',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Pengaturan',
    home: 'Beranda',
    howToPlay: 'Cara Bermain',
    pieceRules: 'Aturan Bidak',
    language: 'Bahasa',
    manageSubscription: 'Kelola Langganan',
    gameHistory: 'Riwayat Permainan',
    analytics: 'Analitik',
    premiumAccount: 'Akun Premium',
    chatEnabled: 'Obrolan: Aktif',
    chatDisabled: 'Obrolan: Nonaktif',
  },

  // Piece Rules
  pieceRules: {
    title: 'Aturan Bidak',
    description: 'Pelajari gerakan bidak',
    selectPiece: 'Pilih Bidak',
    selectedLabel: 'Dipilih:',
    statusLabel: 'Status:',
    statusReady: 'Siap',
    statusViewing: 'Melihat',
    movement: 'Gerakan',
    regularMovement: 'Gerakan Reguler',
    ability: 'Kemampuan',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Gerakan',
    savage: 'Liar',
    birdtype: 'Jenis Burung',
    birdType: 'Jenis Burung',
    wallBlock: 'Blokir Dinding',
    moveblocks: 'Blok Gerakan',
    wallclimb: 'Panjat Dinding',
    lilypad: 'Teratai',
    poisonous: 'Beracun',
    meadow: 'Padang Rumput',
    parasiticfungi: 'Jamur Parasit',
    zombification: 'Zombifikasi',
    fungi: 'Jamur',
    traverse: 'Melintasi',
    capture: 'Tangkap',
    faint: 'Pingsan',
    leap: 'Lompat',
    swing: 'Ayun',
    consume: 'Konsumsi',
    gamble: 'Judi',
    entangle: 'Belitkan',
    ink: 'Tinta',
    rotate: 'Putar',
    backstep: 'Langkah Mundur',
    trample: 'Injak',
    charge: 'Serbu',
    lane: 'Jalur',
    snakestrike: 'Serangan Ular',
    shedskin: 'Ganti Kulit',
    house: 'Rumah',
    plant: 'Jenis Tanaman',
    planttype: 'Jenis Tanaman',
    capturehost: 'Tangkap Inang',
    contagion: 'Penularan',
    lonewolf: 'Serigala Penyendiri',
    hop: 'Melompat',
    decay: 'Membusuk',
    slide: 'Meluncur',
    block: 'Blokir',
    poison: 'Racun',
    infection: 'Infeksi',
    howl: 'Melolong',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Beruang dapat bergerak satu kotak ke segala arah, seperti raja dalam catur',
    bearMovementPost: 'Hanya diblokir oleh bidak teman (kecuali Pohon, Beruang bisa memanjat Pohon!)',
    bearSavage: 'Beruang dapat mengatasi kemampuan bertahan seperti Blokir Badak',
    bearSavagePost: 'Menggunakan Liar, Beruang dapat menangkap bidak apa pun dari arah mana pun, menambah daya mematikan',

    // Crane
    craneMovement: 'Bangau dapat bergerak 1 atau 2 kotak dalam garis lurus',
    craneMovementPost: 'Bangau bahkan bisa terbang melewati bidak lain!',
    craneBirdType: 'Bidak jenis burung tidak dapat menangkap bidak besar atau pemangsa',
    craneBirdTypePost: 'Ini termasuk Pohon, Badak, Beruang dan Serigala',

    // Frog
    frogMovement: 'Katak melompat 2 kotak secara diagonal',
    frogMovementPost: 'Tidak bisa hanya melompat satu kotak',
    frogWallBlock: 'Jika jalur reguler 2 kotak Katak diblokir oleh dinding atau bidak lain, ia tidak dapat menangkap',
    frogWallBlockPost: 'Gerakan regularnya diperpendek menjadi 1 kotak secara diagonal',
    frogWallClimb: 'Ketika Katak berada di dinding papan (Kolom A atau E), ia dapat bergerak naik atau turun satu kotak',
    frogWallClimbPost: 'Kecuali diblokir oleh bidak teman atau Badak di depan Katak',
    frogLilypad: 'Jika Katak belum bergerak dalam permainan, ia dapat pindah ke salah satu dari 3 baris pertama sebagai kemampuan bertahan yang kuat',
    frogLilypadPost: 'Ia dapat menangkap bidak reguler apa pun menggunakan Lompatan Teratai, kecuali Badak di baris yang lebih tinggi',
    frogPoisonous: 'Ketika hewan apa pun menangkap bidak Katak, Anda menjadi keracunan!',
    frogPoisonousPost: 'Bidak yang keracunan melewati giliran berikutnya sebelum pulih',

    // Fungi
    fungiMovement: 'Jamur dapat bergerak satu kotak ke segala arah',
    fungiMovementPost: 'Hanya diblokir oleh bidak sekutu',
    fungiMeadow: 'Jamur mengurangi kemampuan gerakan bidak Pohon musuh',
    fungiMeadowPost: 'Bidak Pohon musuh tidak dapat bergerak dalam jarak 1 kotak dari bidak Jamur',
    fungiParasitic: 'Jamur dapat melumpuhkan bidak Pohon musuh',
    fungiParasiticPost: 'Jika Jamur berada dalam jarak 1 kotak dari Pohon musuh, ia tidak dapat bergerak sampai Jamur menjauh atau ditangkap',
    fungiZombification: 'Jamur dapat menzombifikasi bidak hewan musuh yang menangkapnya, memungkinkan kontrol atas hewan musuh selama satu giliran',
    fungiZombificationPost: 'Bidak yang dizombifikasi juga dianggap sebagai bidak Jamur untuk giliran itu, bahkan jika Jamur adalah raja Anda, permainan tidak berakhir sampai setelah giliran itu',
    fungiFungi: 'Jamur',
    fungiFungiPost: 'Seperti racun, belitan dan infeksi virus, tapi bukan zombifikasi karena bisa menzombifikasi yang lain!',

    // Goat
    goatMovement: 'Kambing dapat bergerak satu kotak ke segala arah',
    goatMovementPost: 'Kambing bergerak lambat tapi memiliki kemampuan yang kuat',
    goatTraverse: 'Kambing dapat melintasi bidak terhubung lainnya untuk menciptakan potensi gerakan yang besar',
    goatTraversePost: 'Kambing tidak dapat melintasi Kambing Pingsan atau bidak Kecil seperti Virus',
    goatCapture: 'Kambing tidak dapat menangkap Pemangsa apa pun',
    goatCapturePost: 'Seperti Beruang atau Serigala',
    goatFaint: 'Kambing dapat pingsan untuk menghindari penangkapan kecuali dari bidak besar seperti Pohon dan Badak',
    goatFaintPost: 'Saat pingsan, lawan dapat "berdiri" di atas kambing pingsan untuk menghentikan gerakannya',

    // Monkey
    monkeyMovement: 'Monyet dapat bergerak satu kotak ke segala arah',
    monkeyMovementPost: 'Tanpa bidak lain untuk digunakan, Monyet memiliki gerakan terbatas',
    monkeyLeap: 'Monyet, seperti permainan dam, dapat melompati bidak lain dalam garis lurus untuk potensi gerakan yang besar',
    monkeyLeapPost: 'Tapi jika melompati bidak musuh, Monyet harus melempar dadu untuk bertahan hidup, 1/6 peluang ditangkap untuk setiap musuh yang dilompati!',
    monkeySwing: 'Jika Monyet menggunakan lompatan melewati Pohon, Monyet mendapat giliran bonus',
    monkeySwingPost: 'Menggunakan ayunan pohon menciptakan kombo sinergis yang kuat antara bidak Monyet dan Pohon',
    monkeyConsume: 'Monyet dapat mengonsumsi bidak Jamur untuk giliran bonus',
    monkeyConsumePost: 'Menghasilkan kombinasi yang menghancurkan ketika dikombinasikan dengan giliran bonus lainnya',
    monkeyGamble: 'Selain melempar dadu untuk melompati musuh, Monyet harus berjudi untuk menangkap Beruang',
    monkeyGamblePost: 'Monyet harus melempar 5 atau 6 pada dadu 6 sisi untuk menangkap Beruang atau ditangkap sendiri',

    // Octopus
    octopusMovement: 'Gurita bergerak satu kotak ke segala arah',
    octopusCapture: 'Gurita hanya dapat menangkap secara ortogonal',
    octopusCapturePost: 'Gurita dapat menangkap atau membelitkan bidak dengan cara yang kompleks, jadi selalu periksa tangkapan merah dan belitan ungu!',
    octopusEntangle: 'Gurita dapat membelitkan bidak musuh yang berdekatan, melumpuhkan mereka, bahkan bisa bergerak satu kotak dan membelitkan musuh!',
    octopusEntanglePost: 'Bidak yang terbelit tidak dapat bergerak sampai Gurita menjauh atau ditangkap',
    octopusInk: 'Gurita dapat menggunakan tinta untuk melarikan diri dari situasi berbahaya, menciptakan hingga 3 bayangan',
    octopusInkPost: 'Membingungkan musuh dan memungkinkan permainan umpan dan penghindaran yang menarik',

    // Penguin
    penguinMovement: 'Penguin meluncur dalam garis lurus di arah yang ditetapkan sampai dinding atau bidak menghalangi gerakannya',
    penguinMovementPost: 'Setelah bergerak, Penguin dalam giliran yang sama dapat mengatur arah akhirnya juga',
    penguinRotate: 'Pada awal pertandingan, Penguin menghadap ke bawah dan harus berputar sebelum bisa meluncur, juga dikenal sebagai tidur',
    penguinRotatePost: 'Penguin di posisi mana pun dapat memilih untuk berputar alih-alih bergerak',
    penguinBirdType: 'Penguin memiliki kemampuan menangkap terbatas, seperti Bangau, ia tidak dapat menangkap bidak besar atau pemangsa seperti Pohon, Badak, Beruang atau Serigala',
    penguinBirdTypePost: 'Setelah menangkap, Penguin dapat berputar ke arah mana pun untuk posisi strategis',

    // Rhino
    rhinoMovement: 'Badak bergerak dua kotak hanya ke depan',
    rhinoMovementPost: 'Tidak bisa hanya bergerak 1 kotak',
    rhinoBackStep: 'Badak dapat bergerak mundur-kiri atau mundur-kanan',
    rhinoCharge: 'Badak sekali per permainan dapat melakukan perjalanan satu kotak tambahan ke depan menggunakan kemampuan serbunya',
    rhinoChargePost: 'Menghasilkan potensi gerakan dan tangkapan yang menghancurkan',
    rhinoTrample: 'Badak menangkap semua bidak di jalur perjalanannya dengan Injak',
    rhinoTramplePost: 'Termasuk bidak Kambing pingsan',
    rhinoLane: 'Badak dapat bertukar tempat dengan bidak sekutu lain yang memungkinkan permainan jalur strategis',
    rhinoLanePost: 'Tapi hanya jika Badak dan bidak Sekutu keduanya belum bergerak',

    // Snake
    snakeMovement: 'Ular dapat bergerak 2 kotak dalam garis lurus',
    snakeMovementPost: 'Ular bergerak tepat 2 kotak kecuali diblokir oleh dinding atau bidak teman',
    snakeMoveBlocks: 'Ketika diblokir oleh dinding atau bidak yang tidak dapat ditangkap, gerakan Ular diperpendek menjadi 1 kotak',
    snakeMoveBlocksPost: 'Masih dapat bergerak dua kotak bahkan jika ada bidak perantara',
    snakeStrike: 'Ular dapat menyerang 3 kotak ke depan jika ada hewan musuh',
    snakeStrikePost: 'Selama tidak ada bidak perantara yang menghalangi jalannya',
    snakeShedskin: 'Sekali per permainan, Ular dapat berganti kulit dan kembali ke baris pertama jika kotaknya kosong',
    snakeShedskinPost: 'Kelahiran kembali ini memberi Ular nyawa tambahan setiap permainan',

    // Tree
    treeMovement: 'Pohon dapat bergerak satu kotak ke depan atau ke kotak mana pun di barisnya dari sisi ke sisi',
    treeMovementPost: 'Selama jalannya tidak diblokir',
    treeHouse: 'Pohon dapat menampung bidak lain, melindungi mereka dari musuh yang tidak bisa memanjat Pohon. Mungkin bidak bisa memanjat seperti Beruang, Bangau, Katak, Jamur, Kambing, Monyet, Gurita dan Ular',
    treeHousePost: 'Ketika bidak yang dapat memanjat pohon menyerang, ia hanya menangkap bidak yang ditampung, melindungi Pohon',
    treeTrample: 'Pohon seperti Badak, menangkap semua bidak di kotak saat bergerak',
    treeTramplePost: 'Ini termasuk Kambing pingsan',
    treePlant: 'Pohon adalah tanaman, bukan hewan jadi kebal terhadap beberapa efek',
    treePlantPost: 'Seperti racun, zombifikasi, belitan dan infeksi virus!',

    // Virus
    virusMovement: 'Virus hanya dapat bergerak ke kotak yang ditempati hewan, yang berjarak dua kotak',
    virusMoveBlocks: 'Virus hanya dapat bergerak satu kotak jika berada di samping dinding',
    virusCaptureHost: 'Ketika Virus mendarat di (dalam) bidak hewan mana pun, ia hanya menginfeksi mereka, mereka masih dapat melanjutkan permainan reguler saat terinfeksi',
    virusCaptureHostPost: 'Virus hanya menangkap bidak ketika meninggalkan inang yang terinfeksi',
    virusContagion: 'Virus dapat menyebar dengan cepat dengan menginfeksi beberapa inang dalam satu giliran',
    virusContagionPost: 'Penularan memungkinkan Virus melakukan sebanyak mungkin gerakan legal yang diinginkan setiap giliran',

    // Wolf
    wolfMovement: 'Serigala dapat bergerak dalam bentuk L, seperti kuda dalam catur',
    wolfMovementPost: 'Tidak terhalang oleh bidak lain mana pun',
    wolfLoneWolf: 'Serigala',
    wolfLoneWolfPost: 'Serigala juga menganggap dirinya sendirian ketika masih memiliki Kambing pingsan atau sekutu virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Seret untuk menjelajah • Cubit untuk zoom',
    dragToExploreDesktop: '🖱️ Seret untuk menjelajah • Gulir untuk zoom',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Kembali',
    next: 'Berikutnya',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'KOTAK PASIR',
    description: 'Bereksperimen & Berlatih',
    mode: 'Mode:',
    modeValue: 'Kotak Pasir',
    status: 'Status:',
    statusReady: 'Siap',
    clearBoard: 'Hapus Papan',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIPEMAIN',
    description: 'Temukan lawan dan bersaing!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Pertandingan Penempatan',
    matchProgress: 'Kemajuan Pertandingan',
    gamesCompleted: '{games} / 10 Permainan Selesai',
    estimatedFinalRating: 'Peringkat Akhir Perkiraan',
    startingRating: 'Peringkat awal',
    matchesRemaining: '{matches} pertandingan tersisa',
    findPlacementMatch: 'Cari Pertandingan Penempatan',

    // Matchmaking modes
    findMatch: 'Cari Pertandingan',
    competitive: 'Kompetitif',
    competitiveDesc: 'Temukan lawan dekat dengan peringkat Anda',
    quick: 'Cepat',
    quickDesc: 'Temukan pertandingan kompetitif dengan cepat',
    casual: 'Santai',
    casualDesc: 'Tanpa peringkat - main untuk bersenang-senang!',
    placement: 'Penempatan',
    placementDesc: 'Selesaikan 10 pertandingan untuk mendapat peringkat',
    startSearch: 'Mulai Pencarian',

    // Searching
    searching: 'Mencari...',
    mode: 'Mode:',
    inQueue: 'Dalam Antrian:',
    players: 'pemain',
    playersPlural: 'pemain',
    cancelSearch: 'Batal Pencarian',

    // Game info
    status: 'Status:',
    ready: 'Siap',
    selectingKing: 'Memilih Raja',
    placingPieces: 'Menempatkan Bidak',
    playing: 'Bermain',
    gameType: 'Jenis Permainan:',
    opponent: 'Lawan:',
    opponentElo: 'ELO Lawan:',
    unranked: 'Tanpa Peringkat',

    // Piece placement
    dragPieces: 'Seret bidak ke papan',
    lightPieces: 'Bidak Terang (Anda)',
    darkPieces: 'Bidak Gelap (Anda)',

    // Waiting states
    waitingForOpponent: 'Menunggu Lawan...',
    waitingForKing: 'Menunggu lawan memilih raja mereka...',

    // Warnings
    invalidPlacement: 'Penempatan Tidak Valid',
    lightTurn: 'Giliran pemain Terang!',
    darkTurn: 'Giliran pemain Gelap!',
    onlyLightPieces: 'Anda hanya dapat menempatkan bidak terang!',
    onlyDarkPieces: 'Anda hanya dapat menempatkan bidak gelap!',
    mustPlaceOnRow: 'Bidak {color} harus ditempatkan di baris {row}!',

    // Chat
    chat: 'Obrolan',
    typeMessage: 'Ketik pesan...',
    send: 'Kirim',
  },

  // Main Page
  mainPage: {
    title: 'CATUR HEWAN',
    subtitle: 'Permainan untuk manusia',
    playersOnline: 'Pemain online saat ini',
    placement: 'Penempatan',
    placementProgress: 'Penempatan',
    challengeAI: 'Tantang AI',
    multiplayer: 'Multipemain',
    sandbox: 'Kotak Pasir',
    tutorials: 'Tutorial',
    shop: 'Toko',
    collection: 'Koleksi',
    history: 'Riwayat',
    analytics: 'Analitik',
    courses: 'Kursus',
    upgradeAccount: 'Tingkatkan akun',
    signIn: 'Masuk',
    playAsGuest: 'Main sebagai Tamu',
    welcomeBack: 'Selamat datang kembali! Anda biasanya bermain sebagai',

    // Learn the Pieces section
    learnThePieces: 'Pelajari bidak',

    // Learn the Rules section
    learnTheRules: 'Pelajari Aturan',
    premiseTitle: 'Premis',
    premiseText: 'Zodiac adalah alternatif catur dengan raja TERSEMBUNYI dari daftar 13 bidak, pilih daftar unik lalu gertakan lawan Anda untuk mengalahkan mereka di papan 5 x 8',
    selectionTitle: 'Pemilihan',
    selectionText: 'Untuk memulai permainan, diam-diam pilih raja Anda, lalu letakkan 5 bidak Anda secara bergantian dengan lawan Anda untuk menciptakan salah satu dari lebih dari 500 miliar keadaan awal.',
    objectiveTitle: 'Tujuan',
    objectiveText: 'Baik baca lawan Anda untuk MENANGKAP raja rahasia mereka atau LARI raja Anda melintasi papan untuk mengamankan kemenangan!',
    competeTitle: 'Bersaing',
    competeText: 'Uji keterampilan Anda di tangga, kembangkan teknik dan strategi pribadi baru, naik peringkat untuk menghadapi yang terbaik!',
    fullRulesButton: 'Untuk aturan resmi lengkap klik di sini',

    // FAQ section
    faqTitle: 'Pertanyaan yang Sering Diajukan',
    faqQuestion1: 'Apa ide di balik catur Zodiac?',
    faqAnswer1: 'Catur Zodiac awalnya terinspirasi oleh kata-kata Bobby Fischer tentang inspirasinya untuk membuat Chess960, kami ingin memperluas ide memerangi hafalan membosankan dan merayakan intuisi manusia dalam kedalaman yang tak terukur!',
    faqQuestion2: 'Mengapa kita membutuhkan alternatif catur',
    faqAnswer2: 'Tidak perlu! Zodiac tidak ingin mengalihkan orang dari bermain catur! Ini adalah pilihan berbeda dengan kekuatan dan kelemahannya sendiri, kami harap Anda bersenang-senang dengannya dan membantu kami mengadaptasi permainan ini untuk menghidupkan permainan baru',
    faqQuestion3: 'Bagaimana cara menang di Catur Zodiac?',
    faqAnswer3: 'Ada tiga cara untuk menang: tangkap bidak raja tersembunyi lawan Anda, lari raja Anda sendiri ke sisi berlawanan dari papan, atau dalam pertandingan dengan kontrol waktu, waktu lawan Anda habis',
    faqQuestion4: 'Apakah ini FAQ?',
    faqAnswer4: 'Ya, Anda dapat melihat pertanyaan apa pun yang terdaftar di FAQ dan jika Anda ingin lebih detail, Anda dapat mengklik pertanyaan lalu membaca detail berikut, seperti detail yang Anda baca sekarang',
    faqQuestion5: 'Berapa lama permainan biasanya berlangsung?',
    faqAnswer5: 'Setiap permainan sangat berbeda! Beberapa permainan berakhir dalam 2 gerakan dan beberapa mungkin memakan waktu 30 menit, kami biasanya cenderung menemukannya di kisaran 5-15 menit!',
    faqQuestion6: 'Apa yang terjadi jika tidak ada yang bisa melakukan gerakan legal?',
    faqAnswer6: 'Jika pemain tidak dapat melakukan gerakan legal apa pun (jalan buntu), permainan berakhir seri. Permainan juga dapat berakhir seri melalui pengulangan (keadaan papan yang sama 3 kali) atau dengan kesepakatan bersama antara pemain!',

    // About section
    aboutButton: 'Tentang',
    privacyPolicy: 'Kebijakan Privasi',
    developerInterface: 'Antarmuka Pengembang',
  },

  // About Modal
  about: {
    title: 'Tentang Zodiac',
    paragraph1: 'Zodiac adalah permainan papan mirip catur yang menggabungkan elemen pemilihan bidak dari permainan seperti LoL dan DotA, dengan mekanik gertakan dari poker atau permainan deduksi sosial.',
    paragraph2: 'Versi awal permainan dibuat pada tahun 2014, dengan nama Shadow Chess. Pada tahun 2018 dirancang ulang menjadi apa yang Anda lihat hari ini, melibatkan daftar bidak yang menyenangkan dengan pola gerakan dan kemampuan yang seimbang namun unik.',
    paragraph3: 'Visi kami adalah merekam semua data gameplay pengguna untuk terus mengembangkan permainan dalam upaya menjaga gameplay tetap segar, mendorong permainan baru.',
    paragraph4: 'Dengan ruang pencarian raksasa Zodiac, informasi tersembunyi dan posisi papan pembukaan, kami berharap dapat menghindari dominasi AI dan menjaga zodiac sebagai permainan untuk manusia!',
  },

  // Privacy Policy
  privacy: {
    title: 'Kebijakan Privasi',
    lastUpdated: 'Terakhir Diperbarui',

    introduction: {
      title: 'Pendahuluan',
      p1: 'Selamat datang di Zodiac Chess ("kami", "milik kami" atau "kita"). Kami berkomitmen untuk melindungi privasi Anda dan memastikan Anda memiliki pengalaman bermain game yang aman dan menyenangkan. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, mengungkapkan, dan melindungi informasi Anda saat Anda menggunakan situs web dan permainan kami.',
      p2: 'Dengan menggunakan Zodiac Chess, Anda setuju dengan pengumpulan dan penggunaan informasi sesuai dengan kebijakan ini. Jika Anda tidak setuju dengan kebijakan dan praktik kami, harap jangan gunakan layanan kami.',
      contact: 'Hubungi kami di:',
    },

    infoCollect: {
      title: 'Informasi yang Kami Kumpulkan',
      accountInfo: {
        title: '1. Informasi Akun',
        item1: 'Alamat Email: Diperlukan untuk pembuatan akun dan komunikasi',
        item2: 'Nama Pengguna: Nama tampilan pilihan Anda',
        item3: 'Kata Sandi: Dienkripsi dan disimpan dengan aman',
      },
      gameData: {
        title: '2. Data Permainan',
        item1: 'Statistik Permainan: Menang, kalah, peringkat ELO, kemajuan pertandingan penempatan',
        item2: 'Data Gameplay: Pilihan bidak, gerakan yang dibuat, strategi yang digunakan',
        item3: 'Riwayat Pertandingan: Catatan permainan yang dimainkan, lawan yang dihadapi',
        item4: 'Pembelian Dalam Permainan: Item kosmetik dan status keanggotaan premium',
      },
      technicalData: {
        title: '3. Data Teknis',
        item1: 'Informasi Perangkat: Jenis browser, sistem operasi',
        item2: 'Data Penggunaan: Halaman yang dikunjungi, waktu yang dihabiskan, fitur yang digunakan',
        item3: 'Penyimpanan Lokal: Preferensi bahasa, pengaturan UI, status permainan sementara',
      },
    },

    children: {
      title: 'Privasi Anak (Kepatuhan COPPA)',
      p1: 'Zodiac Chess dirancang ramah keluarga dan cocok untuk pemain dari segala usia, termasuk anak-anak. Kami sangat berhati-hati untuk mematuhi Undang-Undang Perlindungan Privasi Online Anak (COPPA).',
      p2: 'Untuk pengguna di bawah 13 tahun: Kami merekomendasikan anak-anak menggunakan mode permainan tamu kami, yang tidak memerlukan pembuatan akun atau pengumpulan data. Akun tamu tidak memiliki akses ke fitur obrolan teks, memastikan anak-anak tidak terpapar komunikasi dengan internet yang lebih luas. Jika anak membuat akun, kami memerlukan persetujuan orang tua sebelum mengumpulkan informasi pribadi apa pun.',
      p3: 'Kami TIDAK dengan sengaja mengumpulkan, menggunakan, atau membagikan informasi pribadi dari anak-anak di bawah 13 tahun tanpa persetujuan orang tua yang terverifikasi.',
      p4: 'Keamanan Obrolan: Obrolan teks dinonaktifkan secara otomatis untuk semua akun tamu/sementara. Pemegang akun standar memiliki opsi untuk menonaktifkan fungsi obrolan di pengaturan akun mereka kapan saja.',
      parentalRights: 'Orang tua memiliki hak untuk:',
      right1: 'Meninjau informasi pribadi anak mereka',
      right2: 'Meminta penghapusan data anak mereka',
      right3: 'Menolak pengumpulan atau penggunaan lebih lanjut informasi anak mereka',
      contactUs: 'Untuk menggunakan hak-hak ini atau jika Anda yakin anak Anda telah memberikan informasi pribadi kepada kami, harap hubungi kami segera di contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Bagaimana Kami Menggunakan Informasi Anda',
      item1: 'Menyediakan dan meningkatkan layanan permainan kami',
      item2: 'Mencocokkan Anda dengan lawan yang sesuai berdasarkan tingkat keterampilan',
      item3: 'Melacak kemajuan, statistik, dan pencapaian Anda',
      item4: 'Memproses pembayaran untuk keanggotaan premium dan item kosmetik',
      item5: 'Mengirim pengumuman layanan penting dan pembaruan',
      item6: 'Menganalisis data gameplay untuk meningkatkan keseimbangan permainan dan fitur',
    },

    thirdParty: {
      title: 'Layanan Pihak Ketiga',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Kami menggunakan Firebase untuk autentikasi, penyimpanan database, dan fungsionalitas multipemain. Firebase dapat mengumpulkan data tertentu seperti yang dijelaskan dalam kebijakan privasi mereka.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Kami menggunakan Stripe untuk memproses pembayaran untuk keanggotaan premium dan pembelian dalam aplikasi. Stripe menangani semua informasi kartu pembayaran - kami tidak pernah melihat atau menyimpan detail pembayaran lengkap Anda.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Situs web kami di-hosting di Netlify, yang dapat mengumpulkan data hosting web standar seperti alamat IP dan log akses.',
      },
      adsense: {
        title: 'Google AdSense (Masa Depan)',
        description: 'Kami dapat menampilkan iklan melalui Google AdSense. Iklan ini dapat menggunakan cookie untuk personalisasi. Untuk konten yang ditujukan untuk anak-anak, kami hanya akan menampilkan iklan yang tidak dipersonalisasi sesuai dengan COPPA.',
      },
      viewPolicy: 'Lihat Kebijakan Privasi mereka',
    },

    cookies: {
      title: 'Cookie dan Penyimpanan Lokal',
      description: 'Kami menggunakan penyimpanan lokal browser (mirip dengan cookie) untuk meningkatkan pengalaman Anda:',
      item1: 'Preferensi Bahasa: Mengingat bahasa yang Anda pilih',
      item2: 'Sesi Akun: Menjaga Anda tetap masuk (bekerja dengan Firebase)',
      item3: 'Pengaturan Permainan: Mengingat preferensi UI dan pengaturan kotak pasir Anda',
      item4: 'Cookie Iklan: Jika Anda menyetujui, layanan iklan pihak ketiga dapat menggunakan cookie untuk personalisasi iklan',
    },

    security: {
      title: 'Keamanan Data',
      p1: 'Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi informasi Anda:',
      item1: 'Enkripsi Kata Sandi: Semua kata sandi dienkripsi menggunakan metode standar industri',
      item2: 'Koneksi Aman: Enkripsi HTTPS untuk semua transmisi data',
      item3: 'Aturan Keamanan Firebase: Kontrol akses database yang ketat',
      p2: 'Namun, tidak ada metode transmisi melalui internet yang 100% aman. Meskipun kami berusaha melindungi data Anda, kami tidak dapat menjamin keamanan absolut.',
    },

    retention: {
      title: 'Retensi Data',
      p1: 'Kami menyimpan data Anda sebagai berikut:',
      item1: 'Akun Aktif: Data disimpan saat akun Anda aktif',
      item2: 'Akun Tidak Aktif: Jika akun Anda tidak aktif selama 10 tahun, kami dapat menghapus data Anda',
    },

    rights: {
      title: 'Hak Privasi Anda',
      description: 'Tergantung pada lokasi Anda, Anda mungkin memiliki hak-hak berikut:',
      access: {
        title: 'Akses:',
        description: 'Minta salinan data pribadi Anda',
      },
      correction: {
        title: 'Koreksi:',
        description: 'Minta koreksi data Anda',
      },
      deletion: {
        title: 'Penghapusan:',
        description: 'Minta penghapusan akun dan data Anda',
      },
      portability: {
        title: 'Portabilitas Data:',
        description: 'Minta data Anda dalam format portabel',
      },
      optOut: {
        title: 'Opt-Out:',
        description: 'Keluar dari komunikasi pemasaran',
      },
      contact: 'Untuk menggunakan hak-hak ini, harap hubungi kami di contact@zodiac-chess.com',
    },

    international: {
      title: 'Pengguna Internasional',
      p1: 'Zodiac Chess dioperasikan dari Selandia Baru. Jika Anda mengakses layanan kami dari luar Selandia Baru, harap dicatat bahwa informasi Anda dapat ditransfer ke, disimpan, dan diproses di Selandia Baru dan negara lain tempat penyedia layanan kami beroperasi.',
      p2: 'Dengan menggunakan layanan kami, Anda menyetujui transfer informasi Anda ke negara-negara di luar negara tempat tinggal Anda, yang mungkin memiliki undang-undang perlindungan data yang berbeda.',
    },

    changes: {
      title: 'Perubahan pada Kebijakan Privasi Ini',
      description: 'Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Kami akan memberi tahu Anda tentang perubahan apa pun dengan memposting Kebijakan Privasi baru di halaman ini dan memperbarui tanggal "Terakhir Diperbarui". Perubahan signifikan akan dikomunikasikan melalui email atau pemberitahuan menonjol di situs web kami.',
    },

    contact: {
      title: 'Hubungi Kami',
      description: 'Jika Anda memiliki pertanyaan, kekhawatiran, atau permintaan terkait Kebijakan Privasi ini atau praktik data kami, harap hubungi kami:',
      email: 'Email:',
      company: 'Perusahaan:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Ketentuan Layanan',
    lastUpdated: 'Terakhir Diperbarui',
    back: 'Kembali',
    viewPrivacyPolicy: 'Lihat Kebijakan Privasi',
    acknowledgment: 'Dengan menggunakan Zodiac Chess, Anda mengakui bahwa Anda telah membaca, memahami, dan setuju untuk terikat oleh Ketentuan Layanan ini.',
    acceptance: {
      title: '1. Penerimaan Ketentuan',
      p1: 'Dengan mengakses dan menggunakan Zodiac Chess ("Layanan"), Anda menerima dan setuju untuk terikat oleh Ketentuan Layanan ini. Jika Anda tidak setuju dengan ketentuan ini, mohon jangan gunakan Layanan.',
      p2: 'Kami berhak untuk mengubah ketentuan ini kapan saja. Penggunaan Layanan yang berkelanjutan setelah perubahan merupakan penerimaan terhadap ketentuan yang dimodifikasi.',
    },
    description: {
      title: '2. Deskripsi Layanan',
      p1: 'Zodiac Chess adalah permainan papan strategi online yang menampilkan bidak hewan unik dengan kemampuan khusus. Layanan meliputi:',
      feature1: 'Permainan pemain tunggal melawan lawan AI',
      feature2: 'Pencocokan multiplayer dan permainan kompetitif',
      feature3: 'Tutorial interaktif dan sumber belajar',
      feature4: 'Pembuatan akun dan pelacakan kemajuan',
      feature5: 'Fitur langganan premium opsional',
      feature6: 'Opsi kustomisasi kosmetik',
    },
    accounts: {
      title: '3. Akun Pengguna',
      eligibility: {
        title: '3.1 Kelayakan',
        p1: 'Anda harus berusia minimal 13 tahun untuk membuat akun. Pengguna di bawah 13 tahun dapat menggunakan mode permainan tamu dengan pengawasan orang tua tetapi tidak dapat membuat akun.',
      },
      responsibilities: {
        title: '3.2 Keamanan Akun',
        p1: 'Anda bertanggung jawab untuk:',
        item1: 'Menjaga kerahasiaan kata sandi Anda',
        item2: 'Semua aktivitas yang terjadi di bawah akun Anda',
        item3: 'Segera memberitahu kami tentang penggunaan yang tidak sah',
        p2: 'Kami tidak bertanggung jawab atas kerugian atau kerusakan yang timbul dari akses akun yang tidak sah.',
      },
      prohibited: {
        title: '3.3 Aktivitas yang Dilarang',
        p1: 'Anda TIDAK boleh:',
        item1: 'Membagikan akun Anda dengan orang lain',
        item2: 'Menggunakan beberapa akun untuk memanipulasi peringkat',
        item3: 'Menggunakan bot, skrip, atau alat otomatis untuk bermain',
        item4: 'Melecehkan, menyalahgunakan, atau mengancam pemain lain',
        item5: 'Mengeksploitasi bug atau glitch untuk keuntungan tidak adil',
        item6: 'Melakukan reverse engineering atau mencoba mengakses kode sumber kami',
        p2: 'Pelanggaran aturan ini dapat mengakibatkan penangguhan akun atau larangan permanen.',
      },
    },
    premium: {
      title: '4. Langganan Premium',
      billing: {
        title: '4.1 Penagihan',
        p1: 'Langganan premium diproses melalui Stripe. Dengan membeli langganan premium, Anda mengizinkan kami untuk menagih metode pembayaran Anda secara berulang sampai Anda membatalkan.',
        p2: 'Biaya langganan adalah:',
        item1: 'Paket Bulanan: Ditagih setiap bulan pada hari ulang tahun tanggal pembelian Anda',
        item2: 'Paket Tahunan: Ditagih setiap tahun pada hari ulang tahun tanggal pembelian Anda',
        p3: 'Harga dapat berubah dengan pemberitahuan 30 hari kepada pelanggan aktif.',
      },
      cancellation: {
        title: '4.2 Pembatalan',
        p1: 'Anda dapat membatalkan langganan kapan saja melalui pengaturan akun atau dengan menghubungi dukungan. Pembatalan berlaku pada akhir periode penagihan Anda saat ini.',
        p2: 'Anda akan mempertahankan fitur premium hingga akhir periode berbayar Anda, bahkan setelah pembatalan.',
      },
      refunds: {
        title: '4.3 Pengembalian Dana',
        p1: 'Langganan bulanan: Tidak ada pengembalian dana untuk bulan parsial. Batalkan kapan saja untuk menghentikan tagihan di masa depan.',
        p2: 'Langganan tahunan: Pengembalian dana penuh jika diminta dalam 7 hari setelah pembelian. Setelah 7 hari, pengembalian dana berdasarkan kebijaksanaan kami.',
        p3: 'Pembelian kosmetik: Umumnya tidak dapat dikembalikan. Hubungi dukungan untuk keadaan luar biasa.',
      },
    },
    acceptable: {
      title: '5. Kebijakan Penggunaan yang Dapat Diterima',
      p1: 'Anda setuju untuk menggunakan Zodiac Chess dengan cara yang hormat dan sah. Perilaku yang dilarang meliputi:',
      item1: 'Kecurangan, peretasan, atau mengeksploitasi mekanik permainan',
      item2: 'Pelecehan, ujaran kebencian, atau bahasa diskriminatif',
      item3: 'Spam, iklan, atau ajakan',
      item4: 'Membagikan konten yang tidak pantas (jika chat atau konten buatan pengguna diaktifkan)',
      item5: 'Meniru pengguna lain atau anggota staf',
      item6: 'Mencoba mengganggu atau merusak Layanan',
      p2: 'Kami berhak untuk menyelidiki pelanggaran dan mengambil tindakan yang sesuai, termasuk penghentian akun dan pelaporan kepada pihak berwenang jika diperlukan.',
    },
    intellectual: {
      title: '6. Hak Kekayaan Intelektual',
      ownership: {
        title: '6.1 Konten Kami',
        p1: 'Semua konten permainan, termasuk namun tidak terbatas pada mekanik permainan, karya seni, animasi, efek suara, kode, dan desain, dimiliki oleh Animal Chess Limited atau pemberi lisensi kami.',
        p2: 'Anda diberikan lisensi terbatas, non-eksklusif, tidak dapat dipindahtangankan untuk menggunakan Layanan hanya untuk tujuan hiburan pribadi.',
      },
      userContent: {
        title: '6.2 Konten Pengguna',
        p1: 'Dengan mengirimkan konten (seperti pesan chat, nama pengguna, atau informasi profil), Anda memberi kami lisensi di seluruh dunia, bebas royalti untuk menggunakan, menampilkan, dan mendistribusikan konten tersebut sehubungan dengan Layanan.',
        p2: 'Anda menyatakan bahwa Anda memiliki atau memiliki hak yang diperlukan atas konten apa pun yang Anda kirimkan.',
      },
    },
    disclaimers: {
      title: '7. Penafian dan Batasan Tanggung Jawab',
      p1: 'LAYANAN DISEDIAKAN "APA ADANYA" TANPA JAMINAN APA PUN, BAIK TERSURAT MAUPUN TERSIRAT.',
      p2: 'Kami tidak menjamin bahwa:',
      item1: 'Layanan akan tidak terputus atau bebas kesalahan',
      item2: 'Cacat akan diperbaiki',
      item3: 'Layanan bebas dari virus atau komponen berbahaya',
      item4: 'Hasil dari menggunakan Layanan akan memenuhi harapan Anda',
      p3: 'SEJAUH YANG DIIZINKAN OLEH HUKUM, KAMI TIDAK BERTANGGUNG JAWAB ATAS:',
      item5: 'Kerusakan tidak langsung, insidental, atau konsekuensial apa pun',
      item6: 'Kehilangan keuntungan, data, atau niat baik',
      item7: 'Gangguan layanan atau kehilangan data',
      item8: 'Kerusakan yang melebihi jumlah yang Anda bayarkan kepada kami dalam 12 bulan terakhir',
    },
    privacy: {
      title: '8. Privasi',
      p1: 'Penggunaan Layanan oleh Anda juga diatur oleh Kebijakan Privasi kami, yang menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda.',
      p2: 'Dengan menggunakan Layanan, Anda menyetujui praktik data kami sebagaimana dijelaskan dalam Kebijakan Privasi.',
    },
    changes: {
      title: '9. Perubahan Ketentuan',
      p1: 'Kami berhak untuk mengubah Ketentuan Layanan ini kapan saja. Kami akan memberitahu pengguna tentang perubahan material melalui:',
      item1: 'Pemberitahuan email kepada pengguna terdaftar',
      item2: 'Pemberitahuan yang menonjol di situs web',
      item3: 'Tanggal "Terakhir Diperbarui" yang diperbarui di bagian atas halaman ini',
      p2: 'Penggunaan Layanan Anda yang berkelanjutan setelah perubahan merupakan penerimaan terhadap ketentuan yang dimodifikasi.',
    },
    governing: {
      title: '10. Hukum yang Mengatur',
      p1: 'Ketentuan Layanan ini diatur oleh hukum Selandia Baru, tanpa memperhatikan prinsip-prinsip konflik hukum.',
      p2: 'Setiap perselisihan yang timbul dari ketentuan ini atau penggunaan Layanan oleh Anda akan diselesaikan di pengadilan Selandia Baru.',
    },
    contact: {
      title: '11. Informasi Kontak',
      p1: 'Untuk pertanyaan, kekhawatiran, atau dukungan mengenai Ketentuan Layanan ini:',
      email: 'Email:',
      company: 'Perusahaan:',
      address: 'Alamat:',
    },
    severability: {
      title: '12. Keterpisahan',
      p1: 'Jika ada ketentuan dalam persyaratan ini ditemukan tidak dapat dilaksanakan atau tidak valid, ketentuan tersebut akan dibatasi atau dihilangkan sejauh yang diperlukan, dan ketentuan yang tersisa akan tetap berlaku penuh.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Kebijakan Cookie',
    lastUpdated: 'Terakhir Diperbarui',
    browserInstructions: {
      chrome: 'Pengaturan → Privasi dan Keamanan → Cookie',
      firefox: 'Pengaturan → Privasi & Keamanan → Cookie dan Data Situs',
      safari: 'Preferensi → Privasi → Cookie dan data situs web',
      edge: 'Pengaturan → Privasi, pencarian, dan layanan → Cookie',
    },
    cookieTable: {
      name: 'Nama Cookie',
      purpose: 'Tujuan',
      duration: 'Durasi',
      type: 'Jenis',
    },
    relatedPolicies: {
      title: 'Kebijakan Terkait',
      description: 'Untuk informasi lebih lanjut tentang bagaimana kami menangani data Anda, silakan lihat:',
      privacy: 'Kebijakan Privasi',
      terms: 'Ketentuan Layanan',
    },

    introduction: {
      title: 'Pendahuluan',
      p1: 'Kebijakan Cookie ini menjelaskan bagaimana Zodiac Chess ("kami") menggunakan cookie dan teknologi serupa saat Anda mengunjungi situs web kami.',
      p2: 'Dengan menggunakan situs web kami, Anda menyetujui penggunaan cookie kami sesuai dengan kebijakan ini. Jika Anda tidak setuju, silakan nonaktifkan cookie di pengaturan browser Anda atau jangan gunakan situs web kami.',
    },
    what: {
      title: 'Apa Itu Cookie?',
      p1: 'Cookie adalah file teks kecil yang ditempatkan di perangkat Anda (komputer, smartphone, tablet) saat Anda mengunjungi situs web. Cookie banyak digunakan untuk membuat situs web bekerja secara efisien dan memberikan informasi kepada pemilik situs web.',
      p2: 'Cookie melayani berbagai tujuan, termasuk mengingat preferensi Anda, menganalisis penggunaan situs, dan mengaktifkan fitur tertentu.',
    },
    types: {
      title: 'Jenis Cookie yang Kami Gunakan',
      necessary: {
        title: '1. Cookie yang Diperlukan',
        description: 'Cookie ini penting agar situs web berfungsi dengan baik. Tanpa cookie ini, layanan yang Anda minta tidak dapat disediakan.',
        examples: 'Contoh:',
        item1: 'Cookie autentikasi - Menjaga Anda tetap masuk ke akun Anda',
        item2: 'Cookie keamanan - Melindungi dari aktivitas penipuan',
        item3: 'Cookie sesi - Mempertahankan status permainan Anda selama sesi',
        item4: 'Preferensi persetujuan cookie - Mengingat pilihan cookie Anda',
      },
      analytics: {
        title: '2. Cookie Analitik',
        description: 'Cookie ini membantu kami memahami bagaimana pengunjung berinteraksi dengan situs web kami dengan mengumpulkan informasi anonim tentang kunjungan halaman, waktu yang dihabiskan, dan fitur yang digunakan.',
        provider: 'Penyedia: Firebase Analytics (Google)',
        purpose: 'Tujuan:',
        item1: 'Mengukur lalu lintas situs web dan keterlibatan pengguna',
        item2: 'Mengidentifikasi fitur dan halaman populer',
        item3: 'Memahami demografi pengguna (rentang usia, lokasi umum)',
        item4: 'Meningkatkan kinerja situs web dan pengalaman pengguna',
      },
      advertising: {
        title: '3. Cookie Periklanan',
        description: 'Cookie ini digunakan untuk menampilkan iklan yang relevan bagi Anda. Cookie ini juga membatasi berapa kali Anda melihat iklan dan membantu mengukur efektivitas kampanye periklanan.',
        provider: 'Penyedia: Google AdSense',
        purpose: 'Tujuan:',
        item1: 'Menampilkan iklan yang dipersonalisasi berdasarkan minat Anda',
        item2: 'Mengukur kinerja iklan dan keterlibatan',
        item3: 'Mencegah menampilkan iklan yang sama terlalu sering',
        note: 'Catatan: Pelanggan premium tidak pernah melihat iklan, terlepas dari pengaturan cookie.',
      },
    },
    firstThird: {
      title: 'Cookie Pihak Pertama vs Pihak Ketiga',
      firstParty: {
        title: 'Cookie Pihak Pertama',
        description: 'Ini adalah cookie yang diatur langsung oleh Zodiac Chess. Kami menggunakannya untuk fungsionalitas situs penting, autentikasi, dan mengingat preferensi Anda.',
      },
      thirdParty: {
        title: 'Cookie Pihak Ketiga',
        description: 'Ini adalah cookie yang diatur oleh layanan eksternal yang kami gunakan, seperti Google Analytics dan Google AdSense. Cookie pihak ketiga tunduk pada kebijakan privasi penyedia tersebut.',
      },
    },
    specific: {
      title: 'Cookie Spesifik yang Kami Gunakan',
      tableHeader: 'Di bawah ini adalah daftar terperinci cookie yang digunakan di situs web kami:',
    },
    control: {
      title: 'Cara Mengontrol Cookie',
      consent: {
        title: '1. Banner Persetujuan Cookie',
        description: 'Saat Anda pertama kali mengunjungi situs web kami, Anda akan melihat banner persetujuan cookie. Anda dapat:',
        item1: 'Terima Semua - Izinkan semua cookie (yang diperlukan, analitik, dan periklanan)',
        item2: 'Tolak Opsional - Hanya izinkan cookie yang diperlukan (tanpa analitik atau iklan)',
        item3: 'Sesuaikan - Pilih dengan tepat jenis cookie mana yang ingin Anda izinkan',
      },
      browser: {
        title: '2. Pengaturan Browser',
        description: 'Sebagian besar browser web memungkinkan Anda mengontrol cookie melalui pengaturannya. Anda dapat:',
        item1: 'Memblokir semua cookie',
        item2: 'Hanya menerima cookie pihak pertama',
        item3: 'Menghapus cookie setelah setiap sesi penjelajahan',
        item4: 'Melihat dan menghapus cookie individual',
        links: 'Berikut adalah tautan untuk pengelolaan cookie untuk browser populer:',
      },
      optOut: {
        title: '3. Alat Opt-Out',
        description: 'Untuk cookie periklanan secara khusus, Anda dapat memilih keluar dari iklan yang dipersonalisasi:',
        googleLink: 'Pengaturan Iklan Google',
        googleDesc: ' - Kelola iklan Google yang dipersonalisasi',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Keluar dari periklanan berbasis minat',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Alat opt-out khusus UE',
      },
    },
    impact: {
      title: 'Dampak Menonaktifkan Cookie',
      p1: 'Jika Anda menonaktifkan atau menolak cookie, harap perhatikan bahwa:',
      item1: 'Beberapa bagian situs web mungkin tidak berfungsi dengan baik',
      item2: 'Anda mungkin perlu memasukkan kembali preferensi Anda setiap kunjungan',
      item3: 'Anda mungkin keluar dari akun Anda',
      item4: 'Cookie yang diperlukan wajib agar situs berfungsi - menonaktifkannya akan mencegah Anda menggunakan fitur inti',
    },
    updates: {
      title: 'Pembaruan Kebijakan Cookie Ini',
      p1: 'Kami dapat memperbarui Kebijakan Cookie ini dari waktu ke waktu untuk mencerminkan perubahan dalam praktik kami atau untuk alasan hukum, peraturan, atau operasional.',
      p2: 'Kami akan memberi tahu Anda tentang perubahan signifikan dengan memperbarui tanggal "Terakhir Diperbarui" di bagian atas halaman ini. Harap tinjau kebijakan ini secara berkala.',
    },
    contact: {
      title: 'Hubungi Kami',
      p1: 'Jika Anda memiliki pertanyaan tentang penggunaan cookie kami atau Kebijakan Cookie ini, silakan hubungi kami:',
      email: 'Email:',
      company: 'Perusahaan:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Penguin',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Beruang',
    Crane: 'Bangau',
    Frog: 'Katak',
    Fungi: 'Jamur',
    Goat: 'Kambing',
    Monkey: 'Monyet',
    Octopus: 'Gurita',
    Penguin: 'Penguin',
    Rhino: 'Badak',
    Snake: 'Ular',
    Tree: 'Pohon',
    Virus: 'Virus',
    Wolf: 'Serigala',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
